import { endpoints } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators/map';
import { Observable } from 'rxjs/Observable';
import { Limit, LimiteGeralModel, LimitePrazoCompensacao, LimiteTipoPeriodo } from './models/limits';
import { FormatPricePipe } from '../../shared/format-price.pipe';
import { BaseResult } from '../../shared/models/base.result.model';
import { TransfersDataViewModel } from './models/select-ajust-limits';
import { AdjustLimitResponse } from './models/adjust-limit';
import LimitUtil from '../../utils/limit-utils';

@Injectable()
export class LimitsService {
	private url = endpoints.limits;
	limits: Array<Limit>;
	transfersDataViewModel: TransfersDataViewModel;

	constructor(private http: HttpClient) { }

	getDataLimits(): Observable<any[]> {

		return this.http.get<BaseResult<LimiteGeralModel[]>>(`${endpoints.limits.getLimits}?tipoLimite=TODOS`).pipe(
			map((data: BaseResult<LimiteGeralModel[]>) => {

				const gridLimits: Array<any> = [];

				if (data.Sucesso) {

					const groupedLimits = LimitUtil.groupLimitsByPeriod(data.Retorno);

					gridLimits.push(groupedLimits);
				}

				return gridLimits;
			}));
	}

	getLimitsV2(): Observable<BaseResult<LimiteGeralModel>> {
		return this.http.get<BaseResult<LimiteGeralModel>>(`${this.url.getLimits}?tipoLimite=TODOS`);
	}

	changeLimitValue(changeLimitData: any): Observable<BaseResult<AdjustLimitResponse>> {
		const dataChangeLimitData = {
			Tipo: changeLimitData.tipo,
			Valor: changeLimitData.valor
		};

		return this.http.put<BaseResult<AdjustLimitResponse>>(this.url.getLimits, dataChangeLimitData);
	}
}


// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/limits/limits.service.ts